/**
 * Generate notification email HTML for company
 */
export const generateNotificationEmailHTML = (formData) => {
    const formatField = (label, value) => {
        if (!value || value.trim() === '') return '';
        return `
            <tr>
                <td style="padding: 12px 0; border-bottom: 1px solid #e0e0e0;">
                    <strong style="color: #333333; font-size: 14px; display: inline-block; min-width: 150px;">${label}:</strong>
                    <span style="color: #555555; font-size: 14px;">${value}</span>
                </td>
            </tr>
        `;
    };

    return `
<!DOCTYPE html>
<html lang="pt">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Novo Pedido de Contacto - FielCarga</title>
</head>
<body style="margin: 0; padding: 0; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; background-color: #f5f5f5;">
    <table role="presentation" style="width: 100%; border-collapse: collapse; background-color: #f5f5f5;">
        <tr>
            <td align="center" style="padding: 40px 20px;">
                <table role="presentation" style="max-width: 700px; width: 100%; border-collapse: collapse; background-color: #ffffff; border-radius: 10px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
                    <!-- Header -->
                    <tr>
                        <td style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 40px 30px; text-align: center; border-radius: 10px 10px 0 0;">
                            <h1 style="margin: 0; color: #ffffff; font-size: 28px; font-weight: 600;">Novo Pedido de Contacto</h1>
                            <p style="margin: 10px 0 0 0; color: #ffffff; font-size: 16px; opacity: 0.9;">FielCarga - Formulário de Contacto</p>
                        </td>
                    </tr>
                    
                    <!-- Content -->
                    <tr>
                        <td style="padding: 40px 30px;">
                            <div style="background-color: #f8f9fa; padding: 20px; border-radius: 5px; margin-bottom: 30px;">
                                <p style="margin: 0; color: #333333; font-size: 18px; font-weight: 600;">
                                    📋 Detalhes do Pedido
                                </p>
                                <p style="margin: 10px 0 0 0; color: #888888; font-size: 12px;">
                                    Recebido em: ${new Date().toLocaleString('pt-PT', { dateStyle: 'long', timeStyle: 'short' })}
                                </p>
                            </div>
                            
                            <table role="presentation" style="width: 100%; border-collapse: collapse; margin: 20px 0;">
                                ${formatField('Nome Completo', formData.name)}
                                ${formatField('Email', formData.email)}
                                ${formatField('Telefone', formData.phone)}
                                ${formatField('Assunto', formData.subject)}
                                ${formData.message ? `
                                <tr>
                                    <td style="padding: 12px 0; border-bottom: 1px solid #e0e0e0;">
                                        <strong style="color: #333333; font-size: 14px; display: block; margin-bottom: 8px;">Mensagem:</strong>
                                        <div style="color: #555555; font-size: 14px; line-height: 1.6; background-color: #f8f9fa; padding: 15px; border-radius: 5px; white-space: pre-wrap;">${formData.message}</div>
                                    </td>
                                </tr>
                                ` : ''}
                            </table>
                            
                            <div style="background-color: #e3f2fd; border-left: 4px solid #2196f3; padding: 20px; margin: 30px 0; border-radius: 5px;">
                                <p style="margin: 0; color: #1976d2; font-size: 14px; font-weight: 600;">
                                    ⚡ Ação Requerida
                                </p>
                                <p style="margin: 10px 0 0 0; color: #555555; font-size: 14px; line-height: 1.6;">
                                    Por favor, entre em contacto com o cliente o mais breve possível para processar este pedido.
                                </p>
                            </div>
                        </td>
                    </tr>
                    
                    <!-- Footer -->
                    <tr>
                        <td style="background-color: #f8f9fa; padding: 30px; text-align: center; border-radius: 0 0 10px 10px;">
                            <p style="margin: 0; color: #888888; font-size: 12px;">
                                Este email foi gerado automaticamente pelo sistema de contacto da FielCarga.
                            </p>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</body>
</html>
    `;
};

